import {Controller} from "stimulus"
import DOMUtils from "./../utils/DOMUtils"
import {
    TweenLite,
    Power1,
} from "gsap/all"

export default class extends Controller {

    static targets = ["list"]

    initialize() {

        this.events = []

        document.addEventListener("clipboard-success", (e) => this.pushEvent({title: "Copied to clipboard!"}))

    }

    pushEvent(event) {

        this.events.push(event)

        // Add
        this.template = DOMUtils.createTemplate(`<li class="event-hub__item" style="opacity: 0;"><span class="event-hub__item-inner">${event.title}</span></li>`)
        DOMUtils.insertAtTheEnd(this.$list, this.template.content.querySelector("li"))

        // Suppress
        const $items = this.element.querySelectorAll(".event-hub__item")
        const $item = $items[$items.length - 1]
        const $itemInner = $item.querySelector(".event-hub__item-inner")


        // Animation in
        const height = $itemInner.clientHeight + "px"
        TweenLite.set($item, {height: "0px", opacity: 1})
        TweenLite.to($item, 0.4, {height, onComplete: () => {
            const timer = setTimeout(() => {
                // Animation out
                TweenLite.to($item, 0.4, {
                    height: "0px",
                    onComplete: () => {
                        // remove element
                        $item.remove()
                    }
                })
                clearTimeout(timer)
            }, 1000)
        }})

    }

    get $list() {
        return this.listTarget
    }

}